import thunkMiddleware from 'redux-thunk'

import { configureStore } from '@reduxjs/toolkit'

import dadosPessoaisSlice from './dadosPessoaisSlice'
import simulacaoSlice from './simulacaoSlice'

const store = configureStore({
  reducer: {
    dadosPessoais: dadosPessoaisSlice,
    simulacao: simulacaoSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(thunkMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default () => store
